import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslocoService} from '@jsverse/transloco';
import {RestApiService} from '../../http/rest-api.service';
import {TokenStorageService} from '../jwt/token-storage.service';
import {AuthenticationService} from '../authentication.service';
import {AuthApiRoutesEnum} from '../../http/auth-api-routes.enum';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private readonly _restApiService: RestApiService,
    private readonly _tokenStorageService: TokenStorageService,
    private readonly _authenticationService: AuthenticationService,
    private readonly _snackBar: MatSnackBar,
    private readonly _translocoService: TranslocoService,
  ) {

  }

  // not called directly, but called by framework on each http request
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isNotIntercepted(request)) {
      return next.handle(request);
    }
    return this.addAuthHeaderAndProceedWithRequest(request, next).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.Unauthorized as number) {
          this._authenticationService.logout();
        } else if (error.status === HttpStatusCode.Forbidden as number) {
          this._snackBar.open(
            this._translocoService.translate('SHARED.ERRORS.FORBIDDEN'),
            this._translocoService.translate('SHARED.CLOSE'),
          );
        }
        return throwError(() => error);
      }),
    );
  }

  private isNotIntercepted(request: HttpRequest<any>): boolean {
    const authenticationApiUrl: string = [this._restApiService.authApiUrl, AuthApiRoutesEnum.LOGIN].join('/');
    const registrationApiUrl: string = [this._restApiService.authApiUrl, AuthApiRoutesEnum.REGISTRATION].join('/');
    const forgotPasswordApiUrl: string = [this._restApiService.authApiUrl, AuthApiRoutesEnum.FORGOT_PASSWORD].join('/');
    const resetPasswordApiUrl: string = [this._restApiService.authApiUrl, AuthApiRoutesEnum.RESET_PASSWORD].join('/');
    return request.url.indexOf(authenticationApiUrl) !== -1 ||
      request.url.indexOf(registrationApiUrl) !== -1 ||
      request.url.indexOf(forgotPasswordApiUrl) !== -1 ||
      request.url.indexOf(resetPasswordApiUrl) !== -1 ||
      request.url.indexOf('/assets/') !== -1;
  }

  private addAuthHeaderAndProceedWithRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: string | null = this._tokenStorageService.readAccessToken();
    if (token === null && request.url.includes(AuthApiRoutesEnum.TWO_FA_CHECK as string)) {
      token = this._tokenStorageService.getPreAccessToken();
    }
    const headers: HttpHeaders = request.headers.set('Authorization', `Bearer ${token}`);
    return next.handle(request.clone({headers: headers}));
  }
}
